(function() {
    'use strict';
    var controllerId = 'HomePageController';
    angular.module('app').controller(controllerId, ['common','datacontext', '$cookies', '$modal', '$scope', HomePageController]);

    function HomePageController(common, datacontext, $cookies, $modal, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        activate();

        function activate() {
            var promises = [
                getOrderByStore(),
                get_order_package_aging(),
                get_saved_search_links_sp(),
                get_saved_search_links_p()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated PO List View');
                });
        }

        function getOrderByStore() {
            return datacontext.getOrderByStore().then(function(httpResult) {
                vm.order_list = httpResult.data.data;
            });
        }

        function get_saved_search_links_sp() {
            return datacontext.get_save_search({dashboard:1}).then(function(httpResult) {
                vm.saved_search_links_sp = httpResult.data.data;
                vm.CURRENT_IP_ADDRESS = httpResult.data.CURRENT_IP_ADDRESS;
                console.log(vm.CURRENT_IP_ADDRESS);
            });
        }

        function get_saved_search_links_p() {
            return datacontext.get_product_save_search({dashboard:1}).then(function(httpResult) {
                vm.saved_search_links_p = httpResult.data.data;
            });
        }

        function get_order_package_aging() {

            return datacontext.get_order_package_aging().then(function(httpResult) {

                var hResults = httpResult.data.data;
                $scope.current_time = new Date();
                $scope.orderAging = [];
                $scope.reshipAging = [];
                var cntTotal = 0;
                for ( var i in hResults ) {

                    console.log(hResults[i].order_package_type_id);

                    if ( hResults[i].order_package_type_id === 1 ) {
                    	cntTotal +=  hResults[i].cnt;
                    	$scope.orderAging.push({"age":hResults[i].age.toString(), "cnt": hResults[i].cnt, "cntTotal": cntTotal});
                    } else {
                        $scope.reshipAging.push({"age":hResults[i].age.toString(), "cnt": hResults[i].cnt});
                    }
                }
            });

        }
        $scope.suggestion_box = function () {
          $scope.user_id = $cookies.get('user_id');
          var modalInstance = $modal.open({
               templateUrl: '/app/homepage/suggestion_box.html',
               controller: 'suggestionBoxctrl',
               windowClass: 'small',
               resolve: {
                 user_id: function () {
                     return $scope.user_id;
                 }
               }
           }).result.then(function (result) {

           });

           vm.cancel = function () {
               modalInstance.dismiss('cancel');
           };
       };

    }
})();
(function () {
    'use strict';
    var controllerId = 'suggestionBoxctrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'user_id', suggestionBoxctrl]);

    function suggestionBoxctrl(common, datacontext, $scope, $modalInstance, user_id) {
        var getLogFn = common.logger.getLogFn;
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        console.log("user_id:"+user_id);
        var vm = this;
        $scope.ok = function (data) {
          vm.query = {
            user_id: user_id,
            subject: data.subject,
            message: data.message
          };
          return datacontext.suggestion_box(vm.query).then(function (httpResult) {
              // set new data
              log_success("Message sent. Thank you!");
              vm.results = httpResult.data.data;

              $modalInstance.close();
              return httpResult.data.data;
          });


        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();
